import {
  WSBreadcrumbsItem,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { PayerPayeeStatus } from "@wingspanhq/payments/dist/interfaces";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { usePayerQuery } from "../../../query/payers/queries/usePayerQuery";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { usePayerHistoryResources } from "../hooks/usePayerHistoryResources";
import { getPayerDetailsUrl, PAYERS_PATH } from "../paths";

export const RoutePayerHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ payerId: string }>();
  const payerId = match.params.payerId;
  const queryClient = usePayerQuery(payerId);

  const historyResources = usePayerHistoryResources(payerId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryClient
        }}
      >
        {({ queryClientData: client }) => {
          const clientInfo = wsName({
            user: {
              email: client.user?.email as string,
              profile: client.user?.profile
            },
            member: client.member,
            payeeOwnedData: client.payeeOwnedData
          });

          const isInactive =
            client.payeeOwnedData.status === PayerPayeeStatus.Inactive;

          return (
            <>
              <WSPageToolbar
                title="Client history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  ...(isInactive
                    ? [
                        {
                          label: "Archived clients",
                          onClick: () => {
                            history.push(`${PAYERS_PATH}/archived`);
                          }
                        } as WSBreadcrumbsItem
                      ]
                    : []),
                  {
                    label: clientInfo.getResolvedName(),
                    onClick: () => {
                      history.push(getPayerDetailsUrl(payerId));
                    }
                  },
                  {
                    label: "Client history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
